/**
 * Un navigateur qui ne sait pas afficher le fichier (Chrome Android sur un PDF) le télécharge et
 * laisse l'onglet d'aperçu sur `about:blank`. Tant que l'onglet est resté blanc, son document est
 * de même origine et lisible ; dès que l'aperçu s'affiche, la lecture lève une erreur de sécurité.
 * On s'appuie sur ça plutôt que sur le navigateur déclaré.
 */
export function isPreviewTabBlank(previewWindow: Window): boolean {
  try {
    return previewWindow.location.href === 'about:blank';
  } catch {
    return false;
  }
}

export function closePreviewTabIfBlank(
  previewWindow: Window,
  { attempts = 8, intervalMs = 1000 }: { attempts?: number; intervalMs?: number } = {},
): void {
  let remaining = attempts;
  const check = () => {
    if (previewWindow.closed) return;
    if (!isPreviewTabBlank(previewWindow)) return;
    remaining -= 1;
    if (remaining <= 0) {
      previewWindow.close();
      return;
    }
    window.setTimeout(check, intervalMs);
  };
  window.setTimeout(check, intervalMs);
}
